import { render, staticRenderFns } from "./MultipleFileUpload.vue?vue&type=template&id=22ff0c3c&scoped=true&"
import script from "./MultipleFileUpload.vue?vue&type=script&lang=js&"
export * from "./MultipleFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ff0c3c",
  null
  
)

export default component.exports